/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { BulkActionSkipStatus } from './bulkActionSkipStatus';

/**
 * A single id that was not actioned, with a stable reason code.
 *
 * ``code`` is one of ``ENROLLMENT_NOT_ACTIONABLE`` (wrong status for this
 * action) or ``ENROLLMENT_NOT_FOUND`` (missing / cross-org). ``status`` is
 * the row's current status when known so the UI can explain the skip.
 */
export interface BulkActionSkip {
  enrollment_id: string;
  /** @maxLength 64 */
  code: string;
  status?: BulkActionSkipStatus;
}
